export default "__VITE_ASSET__d04e2434__"